<template>
  <div>
    <b-breadcrumb :items="items" />

    <b-form inline class="mt-5 mb-5">
      <label class="sr-only" for="groupDescription">Description</label>
      <b-form-input
        class="mb-2 mr-sm-2 mb-sm-0"
        id="groupDescription"
        placeholder="Description"
        v-model="printGroup.description"
      ></b-form-input>
      <b-button :disabled="saving" variant="primary" @click="updateDescription"
        >Save</b-button
      >
    </b-form>

    <b-container>
      <b-form>
        <b-form-select
          v-model="selectedServerId"
          @change="loadPrinters"
          :options="servers"
          class="mb-3"
        ></b-form-select>
        <b-form-select
          v-model="selectedPrinterId"
          :options="printers"
          class="mb-3"
        ></b-form-select>
        <b-button @click="addPrinter">Add</b-button>
      </b-form>
    </b-container>
    <printer-list :printers="printGroupPrinters" @deletePrinter="deletePrinter">
    </printer-list>
  </div>
</template>

<script>
import PrintersApi from "@/printers_api";
import Notify from "@/notify";
import PrintGroupPrintersList from "@/components/printers/PrintGroupPrintersList";

export default {
  components: {
    "printer-list": PrintGroupPrintersList,
  },
  mixins: [Notify],
  computed: {
    items() {
      return [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Catalogue",
          href: `/printers/catalogues/${this.printGroup.catalogue_id}/edit`,
        },
        {
          text: "Print Group",
          active: true,
        },
      ];
    },
  },
  data() {
    return {
      printGroup: {},
      printGroupPrinters: [],
      servers: [],
      printers: [],
      printGroupId: null,
      selectedServerId: null,
      selectedPrinterId: null,
      saving: false,
    };
  },
  watch: {
    $route(to) {
      this.printGroupId = to.params.id;
    },
  },
  async created() {
    try {
      this.printGroupId = this.$route.params.id;

      let response = await new PrintersApi(
        this.$auth.getAccessToken()
      ).retrievePrintGroup(this.$route.params.id);
      this.printGroup = response.data;

      response = await new PrintersApi(
        this.$auth.getAccessToken()
      ).retrieveServers();
      const servers = response.data;
      this.servers = servers.map((x) => ({ value: x.id, text: x.host }));
      this.printGroupPrinters = await this.loadPrintGroupPrinters();
    } catch (e) {
      this.notifyError(e.message);
    }
  },
  methods: {
    async loadPrintGroupPrinters() {
      const response = await new PrintersApi(
        this.$auth.getAccessToken()
      ).retrievePrintGroupPrinters(this.printGroupId);
      return response.data;
    },
    async loadPrinters(selectedId) {
      this.printers = [];
      if (!Number.isInteger(parseInt(selectedId, 0))) {
        return;
      }
      try {
        const response = await new PrintersApi(
          this.$auth.getAccessToken()
        ).retrievePrinters(selectedId);
        this.printers = response.data.map((x) => ({
          value: x.id,
          text: x.description,
        }));
      } catch (e) {
        this.notifyError(e.message);
      }
    },
    async loadServers() {
      const response = await new PrintersApi(
        this.$auth.getAccessToken()
      ).retrieveServer();
      return response.data;
    },
    async addPrinter() {
      try {
        await new PrintersApi(this.$auth.getAccessToken()).addPrinterToGroup(
          this.selectedPrinterId,
          this.printGroupId
        );
        this.notifySuccess("Added printer");
        this.printGroupPrinters = await this.loadPrintGroupPrinters();
      } catch (e) {
        this.notifyError(e.message);
      }
    },
    async deletePrinter(printer) {
      try {
        await new PrintersApi(
          this.$auth.getAccessToken()
        ).removePrinterFromGroup(printer.id, this.printGroupId);
        this.notifySuccess("Removed Printer");
        this.printGroupPrinters = await this.loadPrintGroupPrinters();
      } catch (e) {
        this.notifyError(e.message);
      }
    },
    async updateDescription() {
      this.saving = true;
      try {
        try {
          const update = { description: this.printGroup.description };
          await new PrintersApi(this.$auth.getAccessToken()).updatePrintGroup(
            this.printGroup.id,
            update
          );
        } catch (e) {
          this.notifyError(e.message);
        }
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/printers/PrintGroupEdit.vue